import { useTranslation } from 'react-i18next';

export const useWorkAndConnections = () => {
	const { t } = useTranslation();

	const work = [
		{
			Image: '/images/sign.png',
			afterimage: 1,
			title: t('signUp'),
			data: t('signUpText'),
			readmore: '/signup',
			alt: 'sign if img',
		},
		{
			Image: '/images/course.png',
			afterimage: 2,
			title: t('selectCourse'),
			data: t('selectCourseText'),
			readmore: '/courses',
			alt: 'course img',
		},
		{
			Image: '/images/learn.png',
			afterimage: 3,
			title: t('startLearning'),
			data: t('startLearningText'),
			readmore: '/courses',
			alt: ' learn img',
		},
		{
			Image: '/images/successfull.png',
			afterimage: 4,
			title: t('getCertificate'),
			data: t('getCertificateText'),
			readmore: '/',
			alt: 'successfull img',
		},
	];

	const connections = [
		{
			Image: '/images/location.png',
			title: t('ourAddress'),
			data1: t('addressDetails'),
		},
		{
			Image: '/images/phone.png',
			title: t('ourPhone'),
			data1: '+20 11 50020781',
		},
		{
			Image: '/images/email.png',
			title: t('ourEmail'),
			data1: 'schema.aiot@gmail.com',
		},
	];

	return { work, connections };
};
